/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Force currency code to show after price
document.addEventListener('DOMContentLoaded', function() {
  function addCurrencyCode() {
    var currencyCode = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'AUD';
    document.querySelectorAll('.price-item, .product__price, [data-product-price]').forEach(function(el) {
      var text = el.textContent.trim();
      if (text.match(/^\$[\d,.]+$/) && !text.includes(currencyCode)) {
        el.textContent = text + ' ' + currencyCode;
      }
    });
  }

  // Run on page load and after Shopify re-renders prices
  setTimeout(addCurrencyCode, 500);
  setTimeout(addCurrencyCode, 1500);

  // Watch for price changes
  var observer = new MutationObserver(function() {
    setTimeout(addCurrencyCode, 100);
  });
  var priceWrap = document.querySelector('.product__price__wrap, .price__container');
  if (priceWrap) {
    observer.observe(priceWrap, { childList: true, subtree: true, characterData: true });
  }
});


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
